"use client";

import { IconCircleCoinPlusOutline18 } from "nucleo-ui-outline-18";
import ResponsiveModal from "@/components/custom/ResponsiveModal";
import { GlassIcon } from "@/components/ui/glass-icon";
import type { OrganizationWallet } from "@/types/wallet";
import { PolymarketFundingContent } from "./PolymarketFundingContent";

interface PolymarketFundingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  recipientAddress: string;
  wallets: OrganizationWallet[];
  onFundingCompleted: () => void;
}

export function PolymarketFundingModal({
  open,
  onOpenChange,
  recipientAddress,
  wallets,
  onFundingCompleted,
}: PolymarketFundingModalProps) {
  return (
    <ResponsiveModal
      open={open}
      onOpenChange={onOpenChange}
      title="Fund Polymarket"
      contentClass="max-w-md"
      innerClass="p-0"
    >
      <div className="flex min-w-0 flex-col overflow-hidden">
        <div className="flex items-center gap-3 px-5 pb-3 pt-5">
          <GlassIcon icon={IconCircleCoinPlusOutline18} color="blue" size="md" />
          <div className="min-w-0 flex-1">
            <h2 className="body-semibold leading-tight">Fund Polymarket</h2>
            <p className="label-xs text-ds-text-muted mt-0.5">Dedicated trading wallet for Polymarket</p>
          </div>
        </div>

        <PolymarketFundingContent
          recipientAddress={recipientAddress}
          wallets={wallets}
          onFundingCompleted={() => {
            onFundingCompleted();
            onOpenChange(false);
          }}
          onBeforeOpenExternal={() => onOpenChange(false)}
        />
      </div>
    </ResponsiveModal>
  );
}
